import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {createSelector} from 'reselect'
import injectReducer from 'utils/injectReducer'
import {selectProfileType} from 'models/user/selectors'
import reducer from './reducer'
import {loadApps, updateApps, removePermissions} from './actions'

export default function withApps(Component) {
  class Apps extends PureComponent {
    static displayName = `withApps(${
      Component.displayName || Component.name || 'Component'
    })`

    static propTypes = {
      loaded: PropTypes.bool,
      type: PropTypes.string,
      loadApps: PropTypes.func,
      cancelApps: PropTypes.func
    }

    UNSAFE_componentWillMount() {
      const {loaded, loadApps} = this.props

      if (loaded === false) {
        loadApps()
      }
    }

    UNSAFE_componentWillReceiveProps({type, loadApps, cancelApps}) {
      if (type !== this.props.type) {
        if (type) {
          loadApps()
        } else {
          cancelApps()
        }
      }
    }

    render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {loaded, ...props} = this.props

      return <Component {...props} />
    }
  }

  const mapStateToProps = createSelector(
    selectProfileType,
    (state) => state.apps,
    (type, apps) => ({type, ...apps})
  )

  function mapDispatchToProps(dispatch) {
    return {
      loadApps: () => dispatch(loadApps()),
      cancelApps: () => dispatch(updateApps(null)),
      removePermissions: (clientId) => dispatch(removePermissions(clientId))
    }
  }

  const withConnect = connect(mapStateToProps, mapDispatchToProps)
  const withReducer = injectReducer({key: 'apps', reducer})

  return compose(withReducer, withConnect)(Apps)
}
